export default class CidadeService {
    public async get(estadoId: number, cidadesIdIgnorar?: number[]): Promise<Array<{ text: string; value: number }>> {
        try {
            const data = await fetch(
                `https://vettech-api.azurewebsites.net/api/v1/localidades/estados/${estadoId}/municipios`,
            ).resolveWithJSON<{ id: number; nome: string }[]>();

            let cidades = data.map(cidade => ({
                text: cidade.nome.toUpperCase(),
                value: cidade.id,
            }));

            if (cidadesIdIgnorar) {
                cidades = cidades.filter(c => !cidadesIdIgnorar.includes(c.value));
            }

            return cidades;
        } catch {}

        return [];
    }

    public async getCidade(cidadeId: number): Promise<{ nome: string } | null> {
        try {
            return await fetch(
                `https://vettech-api.azurewebsites.net/api/v1/localidades/municipios/${cidadeId}`,
            ).resolveWithJSON<{ nome: string }>();
        } catch {}

        return null;
    }
}

